import {
  BACKEND_CONFIG_LOADED,
  BACKEND_CONFIG_RESET,
  BARCODE_GEN_CONFIG_SET,
  DROPLIST_CONFIG_SET,
  PICKLIST_CONFIG_SET,
} from "../types";
import { readCachedBackendConfig } from "../../utils/backend-config-storage";
import { isAdmin } from "../config";

// Seeded from the last known-good /backend/config response instead of a blind
// `false`, so a reload doesn't disable Picklist/Droplist for the round-trip it
// takes the request to come back. The cache is user-editable, so the CPOS-only
// `isAdmin` gate is re-applied here exactly as the saga applies it — a
// hand-written cache entry must not light up these routes on a POS build.
const cachedConfig = readCachedBackendConfig();
const cachedFlag = (value) => isAdmin && value === true;

const initialState = {
  picklistEnabled: cachedFlag(cachedConfig.picklistEnabled),
  dropListEnabled: cachedFlag(cachedConfig.dropListEnabled),
  barcodeGen: cachedFlag(cachedConfig.barcodeGen),
  // `false` here means "/backend/config hasn't answered yet this session" —
  // NOT "the features are off". Anything that would deny access on a false
  // flag (route registration, the 404 redirect) must wait for this.
  configLoaded: false,
};

const picklistReducer = (state = initialState, action) => {
  switch (action.type) {
    case PICKLIST_CONFIG_SET:
      return { ...state, picklistEnabled: action.data };
    case DROPLIST_CONFIG_SET:
      return { ...state, dropListEnabled: action.data };
    case BARCODE_GEN_CONFIG_SET:
      return { ...state, barcodeGen: action.data };
    case BACKEND_CONFIG_LOADED:
      return { ...state, configLoaded: true };
    // Logout navigates client-side, so the store survives it. Without this the
    // next user on the same terminal inherits the previous session's flags
    // (and `configLoaded: true`, which would let the router act on them before
    // /backend/config has been re-fetched).
    case BACKEND_CONFIG_RESET:
      return {
        picklistEnabled: false,
        dropListEnabled: false,
        barcodeGen: false,
        configLoaded: false,
      };
    default:
      return state;
  }
};

export default picklistReducer;
